<div class="title">
  გადაამოწმე ინფორმაცია
</div>
<div class="monthly">
  <div class="row align-items-center">
    <div class="col-lg-6 col-6">
      <p>დაზღვევის ღირებულება</p>
    </div>
    <div class="col-lg-6 col-6 text-end">
      <span>{{aldagi.dataItem}}₾</span>
    </div>
  </div>
</div>
<form>
  <app-info-card>
  </app-info-card>
</form>
